import { httpClient } from '@/services/http/httpClient'

export type ChangePermissionUserPortfolio = {
  portfolioId: string
  userId: string
  permission: string
}

export const changePermissionUserPortfolio = async ({
  portfolioId,
  userId,
  permission,
}: ChangePermissionUserPortfolio) => {
  await httpClient.put(`/projects/portfolios/${portfolioId}/permission`, {
    permission,
    userId,
  })
}
